/**
 * Application locale used for number and date formatting.
 *
 * Currently a compile-time constant (da-DK). Will be replaced with a
 * tenant-config-backed value once the multi-tenant locale feature lands.
 * All formatting primitives that need a default locale should import from
 * here rather than hardcoding a string literal.
 *
 * @see resources/js/Components/Primitives/NumberInput — primary consumer
 */
export const APP_LOCALE = 'da-DK';
